<template>
	<div class="position-relative z-index-1028">
    <div class="bg-green z-index-1038">
      <div class="ga-container py-1 height-nav">
        <div class="d-flex justify-content-between py-2 w-100">
          <div class="mr-3">
            <template>
              <router-link :to="'/'+getMerchant().code+'/booking'">
                <img src="../../../../assets/img/icon/arrow-white.png" class="mt-1" width="15">
              </router-link>
            </template>
            <!-- <template v-else>
              <div @click="onClick('toggleStep',1)">
                <img src="../../../../assets/img/icon/arrow-white.png" class="mt-1" width="15">
              </div>
            </template> -->
          </div>
          <div class="w-100">
            <div class="">
              <transition name="fade">
                <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1 text-white" v-if="step==1">{{$t('hotel.form-order')}}</p>
                <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1 text-white" v-if="step==2">{{$t('hotel.payment-method.payment-detail')}}</p>
              </transition>
            </div>
          </div>
          <div>
            <router-link :to="'/'+getMerchant().code+'/account'" class="d-table ml-auto">
              <div class="d-table" @click="setActiveRoute('cart')">
                <img 
                  v-if="!isNotLogin()" style="padding: 2px"
                  :src="getCurrentUser().avatar" 
                  width="40" 
                  height="40" 
                  class="rounded-100 border-2-green object-fit"> 
                <img 
                  v-else
                  src="../../../../assets/img/icon/user.png" 
                  width="40" 
                  height="40" 
                  class="rounded-100 p-1 object-fit" 
                  style="background-color: #cfcfcf">
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="ga-container">
        <div class="px-2 pt-2 pb-1">
          <headerStepOrder :step="(step+1)" :need_payment="is_order_need_payment"></headerStepOrder>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import headerStepOrder from '@/components/hotel/be/desktop/headerStepOrder.vue';

	export default{
		props: {
			step: {
				type: Number,
				default: 1
			},
      is_order_need_payment: {
        type: Boolean,
				default: false
      }
		},
    components:{
      headerStepOrder
    },
		methods:{
			...mapGetters(['getMerchant','isNotLogin','getCurrentUser']),
      ...mapMutations(['setActiveRoute']),
      onClick(type,data){
        this.$emit(type,data)
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/cartHeader.vue